module.exports = __webpack_public_path__ + "media/images/svg/instagram-a5c3c59a54c518f09703605bc7701745.svg";